var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from "class-transformer";
import { IsBoolean, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
export const dtcOrganizationId = "dtc";
export const dtcOrganizationName = "HealthEx DTC";
export const dtcOrganizationNotificationName = "HealthEx";
export function isDTCOrganization(organizationId) {
    return organizationId === dtcOrganizationId;
}
export class BaseOrganizationLiteDto {
}
__decorate([
    IsString()
], BaseOrganizationLiteDto.prototype, "id", void 0);
__decorate([
    IsString()
], BaseOrganizationLiteDto.prototype, "name", void 0);
export class PasswordConfiguration {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsNumber(),
    IsOptional()
], PasswordConfiguration.prototype, "passwordExpiryInDays", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], PasswordConfiguration.prototype, "minPasswordLength", void 0);
export class BaseOrganizationPublicProfileDto extends BaseOrganizationLiteDto {
}
__decorate([
    IsString(),
    IsOptional()
], BaseOrganizationPublicProfileDto.prototype, "logoUrl", void 0);
__decorate([
    IsString()
], BaseOrganizationPublicProfileDto.prototype, "onChainAddress", void 0);
__decorate([
    IsString(),
    IsOptional()
], BaseOrganizationPublicProfileDto.prototype, "vanitySubdomain", void 0);
__decorate([
    Type(() => PasswordConfiguration),
    ValidateNested(),
    IsOptional()
], BaseOrganizationPublicProfileDto.prototype, "passwordConfiguration", void 0);
__decorate([
    IsString()
], BaseOrganizationPublicProfileDto.prototype, "address", void 0);
__decorate([
    IsString()
], BaseOrganizationPublicProfileDto.prototype, "city", void 0);
__decorate([
    IsString(),
    IsOptional()
], BaseOrganizationPublicProfileDto.prototype, "state", void 0);
__decorate([
    IsString()
], BaseOrganizationPublicProfileDto.prototype, "zip", void 0);
__decorate([
    IsBoolean()
], BaseOrganizationPublicProfileDto.prototype, "isLive", void 0);
__decorate([
    IsBoolean()
], BaseOrganizationPublicProfileDto.prototype, "ssoEnabled", void 0);
export class IDPAttributes {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], IDPAttributes.prototype, "email", void 0);
__decorate([
    IsString()
], IDPAttributes.prototype, "firstName", void 0);
__decorate([
    IsString()
], IDPAttributes.prototype, "lastName", void 0);
__decorate([
    IsString(),
    IsOptional()
], IDPAttributes.prototype, "title", void 0);
__decorate([
    IsString(),
    IsOptional()
], IDPAttributes.prototype, "permissions", void 0);
__decorate([
    IsString(),
    IsOptional()
], IDPAttributes.prototype, "phone", void 0);
export class SSOConfiguration {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsBoolean(),
    IsOptional()
], SSOConfiguration.prototype, "authnRequestsSigned", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], SSOConfiguration.prototype, "wantAssertionsSigned", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], SSOConfiguration.prototype, "wantMessageSigned", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], SSOConfiguration.prototype, "wantLogoutResponseSigned", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], SSOConfiguration.prototype, "wantLogoutRequestSigned", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], SSOConfiguration.prototype, "isAssertionEncrypted", void 0);
__decorate([
    IsString(),
    IsOptional()
], SSOConfiguration.prototype, "ssoProviderName", void 0);
__decorate([
    IsString(),
    IsOptional()
], SSOConfiguration.prototype, "idpLoginUrl", void 0);
__decorate([
    IsString()
], SSOConfiguration.prototype, "idpMetadataUrl", void 0);
__decorate([
    ValidateNested(),
    Type(() => IDPAttributes)
], SSOConfiguration.prototype, "idpAttributes", void 0);
export class BaseOrganizationDto extends BaseOrganizationPublicProfileDto {
}
__decorate([
    IsString(),
    IsOptional()
], BaseOrganizationDto.prototype, "domain", void 0);
__decorate([
    Type(() => SSOConfiguration),
    ValidateNested(),
    IsOptional()
], BaseOrganizationDto.prototype, "ssoConfiguration", void 0);
__decorate([
    IsBoolean()
], BaseOrganizationDto.prototype, "setupComplete", void 0);
__decorate([
    IsString()
], BaseOrganizationDto.prototype, "adminEmail", void 0);
__decorate([
    IsString(),
    IsOptional()
], BaseOrganizationDto.prototype, "blockchainSigningType", void 0);
__decorate([
    Type(() => OrganizationDataDeliverySettingsDto),
    ValidateNested(),
    IsOptional()
], BaseOrganizationDto.prototype, "dataDeliverySettings", void 0);
export var OrganizationDataDeliveryType;
(function (OrganizationDataDeliveryType) {
    OrganizationDataDeliveryType["NONE"] = "NONE";
    OrganizationDataDeliveryType["S3"] = "S3";
    OrganizationDataDeliveryType["SFTP"] = "SFTP";
})(OrganizationDataDeliveryType || (OrganizationDataDeliveryType = {}));
export class OrganizationDataDeliverySettingsDto {
}
__decorate([
    IsEnum(OrganizationDataDeliveryType),
    IsOptional()
], OrganizationDataDeliverySettingsDto.prototype, "deliveryType", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], OrganizationDataDeliverySettingsDto.prototype, "deliverUncompressedData", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], OrganizationDataDeliverySettingsDto.prototype, "deliverConvertedFHIRData", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], OrganizationDataDeliverySettingsDto.prototype, "optedOutOfBackgroundRefresh", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => OrganizationDataDeliveryS3SettingsDto)
], OrganizationDataDeliverySettingsDto.prototype, "s3Settings", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => OrganizationDataDeliverySFTPSettingsDto)
], OrganizationDataDeliverySettingsDto.prototype, "sftpSettings", void 0);
export class OrganizationDataDeliveryS3SettingsDto {
}
__decorate([
    IsString(),
    IsOptional()
], OrganizationDataDeliveryS3SettingsDto.prototype, "s3BucketName", void 0);
__decorate([
    IsString(),
    IsOptional()
], OrganizationDataDeliveryS3SettingsDto.prototype, "s3AssumeRoleArn", void 0);
__decorate([
    IsString(),
    IsOptional()
], OrganizationDataDeliveryS3SettingsDto.prototype, "s3BucketPath", void 0);
__decorate([
    IsString(),
    IsOptional()
], OrganizationDataDeliveryS3SettingsDto.prototype, "s3BucketRegion", void 0);
export class OrganizationDataDeliverySFTPSettingsDto {
}
__decorate([
    IsString(),
    IsOptional()
], OrganizationDataDeliverySFTPSettingsDto.prototype, "sftpHost", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], OrganizationDataDeliverySFTPSettingsDto.prototype, "sftpPort", void 0);
__decorate([
    IsString(),
    IsOptional()
], OrganizationDataDeliverySFTPSettingsDto.prototype, "sftpUsername", void 0);
__decorate([
    IsString(),
    IsOptional()
], OrganizationDataDeliverySFTPSettingsDto.prototype, "sftpPassword", void 0);
__decorate([
    IsString(),
    IsOptional()
], OrganizationDataDeliverySFTPSettingsDto.prototype, "sftpPath", void 0);
export var OrganizationUpdateFailureReason;
(function (OrganizationUpdateFailureReason) {
    OrganizationUpdateFailureReason["PUBLIC_EMAIL_DOMAIN_CANNOT_BE_USED"] = "PUBLIC_EMAIL_DOMAIN_CANNOT_BE_USED";
    OrganizationUpdateFailureReason["DOMAIN_MUST_BE_THE_SAME_AS_THE_USER_EMAIL_DOMAIN"] = "DOMAIN_MUST_BE_THE_SAME_AS_THE_USER_EMAIL_DOMAIN";
    OrganizationUpdateFailureReason["DOMAIN_ALREADY_USED"] = "DOMAIN_ALREADY_USED";
    OrganizationUpdateFailureReason["INVALID_PAIRING_CODE"] = "INVALID_PAIRING_CODE";
})(OrganizationUpdateFailureReason || (OrganizationUpdateFailureReason = {}));
export class OrganizationGoLiveChecklist {
}
__decorate([
    IsBoolean()
], OrganizationGoLiveChecklist.prototype, "isLive", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], OrganizationGoLiveChecklist.prototype, "logoAdded", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], OrganizationGoLiveChecklist.prototype, "patientAuthenticationAdded", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], OrganizationGoLiveChecklist.prototype, "dataConnectionAdded", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], OrganizationGoLiveChecklist.prototype, "dataDeliveryConfigured", void 0);
__decorate([
    IsString(),
    IsOptional()
], OrganizationGoLiveChecklist.prototype, "vanitySubdomain", void 0);
